/*
 *
 * StructureTimePicker
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 03-Mar-2025
 */

import StructureTimePicker from './StructureTimePicker'

export default StructureTimePicker
